import type { ValidationSchemaProps } from "@/shared/common/types";
import { getRequiredStringValidationSchema } from "@/shared/validations";
import * as Yup from "yup";

export const renameCardValidationSchema = ({ t }: ValidationSchemaProps) => {
  return Yup.object().shape({
    name: getRequiredStringValidationSchema({ t }),
  });
};
